"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _signature_pad = _interopRequireDefault(require("signature_pad"));

var _CircleButton = _interopRequireDefault(require("../../atoms/CircleButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var SignaturePadComponent = function SignaturePadComponent(_ref) {
  var width = _ref.width,
      height = _ref.height,
      onComplete = _ref.onComplete,
      onClean = _ref.onClean,
      showButtons = _ref.showButtons,
      penColor = _ref.penColor,
      minWidth = _ref.minWidth,
      maxWidth = _ref.maxWidth;
  var canvas = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      signaturePad = _useState2[0],
      setSignaturePad = _useState2[1];

  (0, _react.useEffect)(function () {
    if (canvas && !signaturePad) {
      canvas.current.onselectstart = function () {
        return false;
      };

      setSignaturePad(new _signature_pad.default(canvas.current, {
        penColor: penColor,
        minWidth: minWidth,
        maxWidth: maxWidth
      }));
    }
  }, [canvas, signaturePad]);
  var handleOnClean = (0, _react.useCallback)(function () {
    if (signaturePad) {
      signaturePad.clear();
    }

    if (onClean) {
      onClean();
    }
  }, [signaturePad, onClean]);
  var handleOnComplete = (0, _react.useCallback)(function () {
    if (onComplete) {
      var data = signaturePad.toDataURL();
      onComplete(data, signaturePad.isEmpty(), signaturePad);
    }
  }, [signaturePad, onComplete]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "signature-pad",
    style: {
      width: width
    }
  }, /*#__PURE__*/_react.default.createElement("canvas", {
    className: "bg-gray-100 border-2 z-0 border-gray-200",
    ref: canvas,
    width: width,
    height: height,
    style: {
      touchAction: 'none'
    }
  }), showButtons && /*#__PURE__*/_react.default.createElement("div", {
    className: "signature-pad__buttons flex -mt-7 justify-center z-10 relative"
  }, /*#__PURE__*/_react.default.createElement(_CircleButton.default, {
    onClick: handleOnClean,
    type: "refresh",
    className: "mr-6"
  }), /*#__PURE__*/_react.default.createElement(_CircleButton.default, {
    onClick: handleOnComplete
  })));
};

SignaturePadComponent.propTypes = {
  width: _propTypes.default.number,
  height: _propTypes.default.number,
  onComplete: _propTypes.default.func,
  onClean: _propTypes.default.func,
  showButtons: _propTypes.default.bool,
  penColor: _propTypes.default.string,
  minWidth: _propTypes.default.number,
  maxWidth: _propTypes.default.number
};
SignaturePadComponent.defaultProps = {
  width: 664,
  height: 375,
  showButtons: true,
  penColor: 'black',
  minWidth: 1,
  maxWidth: 4
};
var _default = SignaturePadComponent;
exports.default = _default;